import { type TOptional } from '@/types/common';

const decodeAKFromUrlParam = (value?: string | null): TOptional<string> => {
  if (value) return value.trim().replace(/\s/g, '+');
};

export default decodeAKFromUrlParam;
